module.exports = __webpack_public_path__ + "img/mortgageSwissLifeBanner.a9d76d0.webp";